const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class FleetAccountServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createFleetAccount(options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/fleetAccounts`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateFleetAccount(fleetAccount) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/fleetAccounts/${fleetAccount.id}`,
        method: 'PATCH',
        data: {
          accountNumber: fleetAccount.accountNumber,
          corporationId: fleetAccount.corporationId,
          fleetId: fleetAccount.fleetId,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteFleetAccount({ id }, options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/fleetAccounts/${id}`,
        method: 'DELETE',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getFleetAccounts({ fleetId, businessAccountId }) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/business-account-fields/${businessAccountId}?fleetId=${fleetId}`);
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listFleetAccounts({ sort, page = 0, maxPerPage = 10, corporationId, fleetId }) {
    try {
      const params = { sort, page, maxPerPage };
      if (corporationId) {
        params.corporationId = corporationId;
      }
      if (fleetId) {
        params.fleetId = fleetId;
      }

      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/fleetAccounts`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async validateAccount({ fleetId, accountNumber }) {
    try {
      const params = { fleetId };

      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/fleetAccounts/validate/${accountNumber}`, {
        params,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listFleets() {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/fleets`);
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  FleetAccountServiceConnector,
};
